// Mobile-first input. The player moves toward wherever the pointer is held
// (touch or mouse). A pointer down anywhere in the play area steers; releasing
// stops. This reads as a "drag to move" joystick without an on-screen stick.

export class Input {
  /** Desired move direction in [-1,1] range, magnitude ~1 when steering. */
  dirX = 0;
  dirY = 0;
  active = false;

  private canvas: HTMLCanvasElement;

  constructor(canvas: HTMLCanvasElement) {
    this.canvas = canvas;
    canvas.addEventListener("pointerdown", this.onDown, { passive: false });
    canvas.addEventListener("pointermove", this.onMove, { passive: false });
    window.addEventListener("pointerup", this.onUp);
    window.addEventListener("pointercancel", this.onUp);
  }

  private setFromEvent(e: PointerEvent) {
    const rect = this.canvas.getBoundingClientRect();
    // Direction is relative to screen center — pull toward where the thumb is.
    const cx = rect.width / 2;
    const cy = rect.height / 2;
    const px = e.clientX - rect.left;
    const py = e.clientY - rect.top;
    let dx = px - cx;
    let dy = py - cy;
    const len = Math.hypot(dx, dy);
    // Dead zone near the center so tiny jitters don't wiggle the player.
    const dead = 18;
    if (len <= dead) {
      this.dirX = 0;
      this.dirY = 0;
      return;
    }
    // Normalize, then ramp magnitude up to 1 over a short travel for fine control.
    const mag = Math.min(1, (len - dead) / 140);
    dx /= len;
    dy /= len;
    this.dirX = dx * mag;
    this.dirY = dy * mag;
  }

  private onDown = (e: PointerEvent) => {
    e.preventDefault();
    this.active = true;
    this.setFromEvent(e);
  };

  private onMove = (e: PointerEvent) => {
    if (!this.active) return;
    e.preventDefault();
    this.setFromEvent(e);
  };

  private onUp = () => {
    this.active = false;
    this.dirX = 0;
    this.dirY = 0;
  };
}
